<template>
  <div class="cases-page">
    <section class="page-hero portfolio-hero">
      <div class="container portfolio-hero">
        <div class="portfolio-hero__summary-bar">
          <span class="eyebrow">{{ content.eyebrow }}</span>
          <p class="page-copy">{{ content.title }}</p>
          <p class="portfolio-hero__note">{{ content.intro }}</p>
        </div>
      </div>
    </section>

    <section class="section portfolio-cases-section">
      <div class="portfolio-cases__viewport">
        <div class="portfolio-cases">
          <article
            v-for="(item, index) in content.items"
            :key="item.title"
            :class="[
              'card-panel portfolio-case',
              { 'portfolio-case--reverse': index % 2 === 1 }
            ]"
          >
            <div class="portfolio-case__gallery">
              <figure
                v-for="(image, imageIndex) in item.images"
                :key="image.src"
                :class="[
                  'portfolio-case__image-tile',
                  { 'portfolio-case__image-tile--hero': imageIndex === 0 }
                ]"
              >
                <img
                  :src="image.src"
                  :alt="image.alt"
                >
              </figure>
            </div>
            <div class="portfolio-case__body">
              <span class="eyebrow">{{ item.category }}</span>
              <h2>{{ item.title }}</h2>
              <div class="portfolio-case__meta">
                <span v-for="meta in item.meta" :key="meta">{{ meta }}</span>
              </div>
              <div class="portfolio-case__sections">
                <section v-for="section in item.sections" :key="section.label">
                  <h3>{{ section.label }}</h3>
                  <p v-for="line in section.body" :key="line">{{ line }}</p>
                </section>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="section-tight portfolio-itineraries">
      <div class="container">
        <div class="card-panel portfolio-itineraries__intro">
          <span class="eyebrow">{{ content.itinerariesEyebrow }}</span>
          <h2 class="section-title">{{ content.itinerariesTitle }}</h2>
        </div>

        <div class="portfolio-itineraries__list">
          <article
            v-for="itinerary in content.itineraries"
            :key="itinerary.title"
            class="card-panel portfolio-itinerary"
          >
            <div class="portfolio-itinerary__header">
              <h3>{{ itinerary.title }}</h3>
            </div>
            <div class="portfolio-itinerary__table-wrap">
              <table class="portfolio-itinerary__table">
                <thead>
                  <tr>
                    <th>Day</th>
                    <th>Place</th>
                    <th>Transportation</th>
                    <th>Itinerary</th>
                    <th>Meal</th>
                    <th>Hotel</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, rowIndex) in itinerary.rows" :key="itinerary.title + '-' + rowIndex">
                    <td>{{ row.day }}</td>
                    <td>
                      <p v-for="(line, lineIndex) in row.place" :key="'place-' + rowIndex + '-' + lineIndex">{{ line }}</p>
                    </td>
                    <td>
                      <p v-for="(line, lineIndex) in row.transportation" :key="'transportation-' + rowIndex + '-' + lineIndex">{{ line }}</p>
                    </td>
                    <td>
                      <p v-for="(line, lineIndex) in row.itinerary" :key="'itinerary-' + rowIndex + '-' + lineIndex">{{ line }}</p>
                    </td>
                    <td>
                      <p v-for="(line, lineIndex) in row.meal" :key="'meal-' + rowIndex + '-' + lineIndex">{{ line }}</p>
                    </td>
                    <td>
                      <p v-for="(line, lineIndex) in row.hotel" :key="'hotel-' + rowIndex + '-' + lineIndex">{{ line }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
var supplementaryItineraries = [
  {
    title: 'SAMPLE Osaka-Tokyo Sakura Tour 6N7D',
    rows: [
      {
        day: 'Day1',
        place: ['KIX', 'Osaka'],
        transportation: ['Private Coach'],
        itinerary: [
          'Arrival',
          'Flight Info',
          'TBD',
          'Transfer to Tokyo hotel',
          '*Sightseeing will depend on the flight’s arrival time',
          '19:30 Group Dinner near the Hotel',
          'Return to the hotel'
        ],
        meal: ['✕', '✕', 'D'],
        hotel: ['Osaka Hotel']
      },
      {
        day: 'Day2',
        place: ['Osaka'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel',
          '=====Optional Tour(within 8 hours)=====',
          '9:50 Depart from hotel to Osaka Castle Park',
          '10:00-11:30 Cherry Blossom Viewing and Osaka Castle Sightseeing',
          '☆cherry blossom spot',
          '*Admission fee required',
          'Transfer to Tenjinbashisuji Area',
          '12:00-13:30 Shopping and Lunch on your own at Tenjinbashisuji Shopping Street',
          '★Meet at Osaka Tenmangu Shrine after passing through Tenjinbashisuji Shopping Street',
          '14:00-15:00 Osaka Tenmangu Shrine☆cherry blossom spot',
          '15:00-16:00 Walk to Nakanoshima Park (10 min) ☆cherry blossom spot',
          'Transfer to Dotonbori/Shinsaibashi Area',
          '16:30-18:00 Shopping at Dotonbori/Shinsaibashi Area',
          'Back to hotel by private bus',
          '===================='
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Same as above']
      },
      {
        day: 'Day3',
        place: ['Osaka'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel & check-out',
          '=====Optional Tour(within 8 hours)=====',
          '10:00 Depart from hotel to Expo ’70 Commemorative Park',
          '*Admission fee required to enter Natural & Cultural Gardens + Japanese Garden',
          '☆cherry blossom spot',
          '10:30-13:30 Cherry blossom viewing at Expo ’70 Park / Lunch on your own at Lalaport EXPOCITY',
          '14:00-16:00 Visit Kema Sakuranomiya Park and walk through the Mint Bureau',
          '☆cherry blossom spot',
          'Transfer to Umeda Area',
          '16:30-18:00 Shopping at Umeda Area',
          'Back to hotel by private bus',
          '===================='
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Same as above']
      },
      {
        day: 'Day4',
        place: ['Osaka', 'Tokyo'],
        transportation: ['Private Coach', 'Bullet train', 'Private Coach'],
        itinerary: [
          'Breakfast at the hotel',
          '11:00 Check out',
          '11:10 Depart from Hotel to Shin-Osaka Station',
          '11:45 Arrived at Shin-Osaka Station',
          'Lunch on your own inside the station',
          '13:06-15:33 Transfer to Tokyo by bullet train on your own (NOZOMI 22)',
          'Meet with the guide at Tokyo Station',
          '16:00 Arrive at hotel, check-in',
          'Rest of the day at your own leisure'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Tokyo Hotel']
      },
      {
        day: 'Day5',
        place: ['Tokyo'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel',
          '=====Optional Tour (within 8 hours)=====',
          '10:00 Depart from hotel to Ueno Park',
          '10:10-11:30 Ueno Park ☆cherry blossom spot',
          '11:30-13:00 Shopping and Lunch on your own at Ameya-Yokocho Shopping Street',
          'Transfer to Shinjuku Area',
          '13:30-15:00 Visit Shinjuku Gyoen',
          '☆cherry blossom spot',
          '*Admission fee required',
          'Transfer to Nakameguro Area',
          '15:30-16:30 Stroll by Meguro rive',
          '☆cherry blossom spot',
          'Transfer to Chidori Area',
          '17:00-18:00 Stroll by Chidorigafuchi',
          '☆cherry blossom spot',
          'Back to hotel by private bus',
          '===================='
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Same as above']
      },
      {
        day: 'Day6',
        place: ['Tokyo'],
        transportation: ['NIL'],
        itinerary: [
          'Breakfast at the hotel',
          'Full day at your own leisure',
          '18:40 Meet with the guide at the Hotel Lobby',
          '19:00',
          'Group Dinner at Ginza',
          'Back to the hotel with guide (10-minute walk)'
        ],
        meal: ['B', '×', '×'],
        hotel: ['Same as above']
      },
      {
        day: 'Day7',
        place: ['Tokyo', 'NRT'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel',
          '10:00 Hotel check out',
          'Full day Tokyo sightseeing with Russian-speaking guide',
          '10:30-11:30 Imperial Palace',
          '12:00-13:30 Tsukiji Market',
          '(Lunch on your own)',
          '14:00-15:30 Asakusa (Senso-ji Temple)',
          '16:00-17:30 Akihabara',
          'Transfer to the Airport by private bus with guide',
          '19:00 Arrive at NRT Airport'
        ],
        meal: ['B', '×', '×'],
        hotel: ['-']
      }
    ]
  },
  {
    title: 'Hokkaido 8 Days Tour',
    rows: [
      {
        day: 'Day1',
        place: ['Seoul', 'Sapporo', 'Noboribetsu'],
        transportation: ['Private Coach'],
        itinerary: [
          'Flight Info',
          'TBC',
          'Toya lake',
          'Cruise Nakajima island',
          'Ropeway Usuzan and enjoy crater Showa Shinzan',
          '*Admission fee required',
          'Nobonbetsu',
          'free time to walk around in onsen town',
          'Check in to the hotel',
          'Dinner at the hotel'
        ],
        meal: ['✕', '✕', 'D'],
        hotel: ['Noboribetsu']
      },
      {
        day: 'Day2',
        place: ['Nobonbetsu', 'Shikotsu', 'Sapporo'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel & check-out',
          'Take ropeway and visit bears park',
          '*Admission fee required',
          'Jigokudani crater',
          'walk the trail with the geysers',
          'Oyunuma onsen pond',
          'Shikotsu blue lake',
          'Stop at the visitors center',
          'Red bridge ruins',
          'Free time for pictures',
          'Sapporo',
          'Free time in Susukino area',
          'Dinner with traditional grilled lamp',
          'Check in to the hotel'
        ],
        meal: ['B', '✕', 'D'],
        hotel: ['Sapporo']
      },
      {
        day: 'Day3',
        place: ['Sapporo'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel',
          'Odori part',
          'TV Tower',
          '*Admission fee required',
          'Mount moiwa',
          '*Admission fee required',
          'Drive to Otaru',
          'Canal boat tour',
          '*Admission fee required',
          'Free time to walk in Sakaimachi street to enjoy sushi',
          'Return to Sapporo and direct to Susukino area.',
          'Free time to walk around',
          'Return to the hotel'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Same as above']
      },
      {
        day: 'Day4',
        place: ['Sapporo', 'Furano', 'Biei', 'Asahikawa'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel & check-out',
          'Furano Mingle terrace',
          'Free time to walk around',
          'Shirogane blue lake Biei',
          'Free time around the lake.',
          'Asahikawa',
          'Visit the zoo',
          '*Admission fee required',
          'Free time to walk around in the city center',
          'Dinner including local ramen',
          'Check in to the hotel'
        ],
        meal: ['B', '✕', 'D'],
        hotel: ['Asahikawa']
      },
      {
        day: 'Day5',
        place: ['Asahikawa', 'Kurodate', 'Abashiri'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel & check-out',
          'Kurodate mountain, use ropeway',
          'Abashiri',
          'Notoro Misaki cape',
          'Lighthouse',
          'Kitahama station',
          'Museum of northern people.',
          '*Admission fee required',
          'Check in to the hotel',
          'Dinner at the hotel'
        ],
        meal: ['B', '✕', 'D'],
        hotel: ['Saromako Lake']
      },
      {
        day: 'Day6',
        place: ['Abashiri', 'Kushiro'],
        transportation: ['Private Coach'],
        itinerary: [
          'Breakfast at the hotel & check-out',
          'Lake Kushhano',
          'Bihoro pass',
          'Sunayu beach.',
          'Akan Mashu national park',
          'Lake Mashu',
          'Akan kohan Ainu village.',
          '*Admission fees apply depending on the experience or performance program',
          'Tsurui - Crane sanctuary',
          'Arrive in Kushiro,',
          'Dinner in a local restaurant including seafood and sushi.',
          'Check in to the hotel'
        ],
        meal: ['B', '✕', 'D'],
        hotel: ['Kushiro']
      },
      {
        day: 'Day7',
        place: ['Kushiro', 'Tokyo'],
        transportation: ['Private Coach'],
        itinerary: [
          'Check-out *early morning',
          'Visit Washo fish market and drive to the airport',
          'Morning flight to Tokyo',
          'KUH→HND',
          'Arrival and visit Asakusha and Nakamichi Dori area',
          'Ginza and dinner at Sapporo restaurant',
          'Check in to the hotel'
        ],
        meal: ['✕', '✕', 'D'],
        hotel: ['Tokyo']
      },
      {
        day: 'Day8',
        place: ['Tokyo', 'NRT'],
        transportation: ['Private Coach'],
        itinerary: ['Departure', 'Flight Info'],
        meal: ['B', '✕', '✕'],
        hotel: ['-']
      }
    ]
  },
  {
    title: 'Japan Standard Itinerary 10 Days',
    rows: [
      {
        day: 'Day1',
        place: ['Haneda or Narita', 'airport', 'Tokyo'],
        transportation: ['Hire Car', '/Coach'],
        itinerary: ['Transfer from Narita or Haneda Airport', 'to Hotel'],
        meal: ['✕', '✕', '✕'],
        hotel: ['Tokyo Hotel']
      },
      {
        day: 'Day2',
        place: ['Tokyo'],
        transportation: ['Hire Car', '/Coach'],
        itinerary: [
          'Tokyo Sightseeing',
          '・Tsukiji',
          '・Asakusa -Sensoji and Nakamise Street',
          '・Harajyuku ＆Meiji Jingu Shrine',
          '・Shibuya Crossing Street'
        ],
        meal: ['B', '✕', '✕', '-'],
        hotel: ['Tokyo Hotel']
      },
      {
        day: 'Day3',
        place: ['Tokyo', 'Mt.Fuji', 'Lake Kawaguchi'],
        transportation: ['Hire Car', '/Coach'],
        itinerary: [
          '- Mt.Fuji 5th Station or World Heritage Center (in rainy case)',
          '-Hakone Ropeway',
          '-Ashinoko Lake Mini Cruise (Around 30min)'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Lake Kawagushi Hotel']
      },
      {
        day: 'Day4',
        place: ['Lake Kawaguchi', 'Nagano', 'Takayama'],
        transportation: ['Hire Car', '/Coach'],
        itinerary: [
          'Transfer to Nagano',
          '-Matsumoto Castle',
          '-Daio Wasabi Farm',
          'Transfer to Takayama'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Takayama Hotel']
      },
      {
        day: 'Day5',
        place: ['Takayama', 'Shirakawa-go', 'Mino', 'Kyoto'],
        transportation: ['Hire Car', '/Coach'],
        itinerary: [
          'Takayama Sightseeing',
          '-Miyagawa Morning Market and Sanmachi Street',
          'Transfer to Shirakawago',
          '-Kanda House or Iwase House',
          'Transfer to Mino',
          '-Washi Paper Experience',
          'Transfer to Kyoto'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Kyoto Hotel']
      },
      {
        day: 'Day6',
        place: ['Kyoto'],
        transportation: ['Hire Car', '/Coach'],
        itinerary: [
          'Kyoto Sightseeing',
          '-Kiyomizu Temple',
          '-Gion Street (HanamiKoji etc)',
          '-Kinkakuji Temple',
          '-Arashiyama',
          '-Kiyomizu Temple'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Kyoto Hotel']
      },
      {
        day: 'Day7',
        place: ['Kyoto', 'Nara', 'Osaka'],
        transportation: ['Hire Car', '/Coach'],
        itinerary: [
          'Transfer to Fushimi Inari Shrine',
          '- Fushimi Inari Shrine',
          'Transfer to Nara',
          '-Todaiji Tenmle',
          '-Nara Park',
          'Transfer to Osaka',
          '-Shinsaibashi'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Osaka Hotel']
      },
      {
        day: 'Day8',
        place: ['Shin Osaka', 'Himeji', 'Hiroshima'],
        transportation: ['Public Train', 'Bullet', 'Train'],
        itinerary: [
          'Public Train to Shin-Osaka Station',
          'Bullet Train to Himeji Station',
          '–Himeji Castle',
          'Bullet Train to Hiroshima Station',
          'Hiroshima Sightseeing',
          '-Peace Memorial Park',
          '-Atomic Bomb Dome'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Hiroshima Hotel']
      },
      {
        day: 'Day9',
        place: ['Hiroshima', 'Miyajima', 'Osaka'],
        transportation: ['Public Train', 'Ferry', 'Public Train', 'Bullet Train'],
        itinerary: [
          'Transfer to Miyajima guchi Station',
          'Go to Miyajima by Ferry',
          '-Itsukushima Shrine',
          'Return by Ferry',
          'Transfer to Hiroshima Station by Public Train',
          'Bullet Train from Hiroshima – Osaka'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['Osaka Hotel']
      },
      {
        day: 'Day10',
        place: ['Osaka', 'KIX', '(Kansai International Airport)'],
        transportation: ['Hire Car', '/Coach'],
        itinerary: [
          'Hotel Check-Out',
          'Osaka Sightseeing until departure',
          'Osaka Castle Park, Kuromon Market',
          'Transfer to KIX',
          '(Kansai International Airport)',
          'Airline Check-in.',
          'Flight Departure'
        ],
        meal: ['B', '✕', '✕'],
        hotel: ['-']
      }
    ]
  }
];

var portfolioImages = {
  mice: [
    {
      src: '/images/portfolio4.jpg',
      alt: 'Corporate incentive gala event in Japan'
    },
    {
      src: '/images/portfolio1.jpg',
      alt: 'Large group incentive travel program'
    },
    {
      src: '/images/portfolio5.jpg',
      alt: 'Japanese cultural performance for corporate guests'
    },
    {
      src: '/images/portfolio2.jpg',
      alt: 'Premium event setup during cherry blossom season'
    },
    {
      src: '/images/portfolio3.jpg',
      alt: 'Wellness and cultural incentive experience'
    }
  ],
  education: [
    {
      src: '/images/portfolio9.jpg',
      alt: 'Youth study tour in Japan'
    },
    {
      src: '/images/portfolio6.jpg',
      alt: 'Student cultural exchange activity'
    },
    {
      src: '/images/portfolio10.jpg',
      alt: 'Academic visit and campus learning program'
    },
    {
      src: '/images/portfolio7.jpg',
      alt: 'Youth camp and accommodation support'
    },
    {
      src: '/images/portfolio8.jpg',
      alt: 'Modern culture exploration for international students'
    }
  ],
  seasonal: [
    {
      src: '/images/portfolio15.png',
      alt: 'Seasonal cherry blossom and autumn leaves group tour'
    },
    {
      src: '/images/portfolio11.jpg',
      alt: 'Scenic sightseeing route across Japan'
    },
    {
      src: '/images/season1.png',
      alt: 'Cherry blossom seasonal sightseeing highlight'
    },
    {
      src: '/images/season2.png',
      alt: 'Autumn leaves seasonal group travel highlight'
    },
    {
      src: '/images/portfolio13.jpg',
      alt: 'Restaurant and sightseeing stop for seasonal travelers'
    }
  ]
};

var portfolioContent = {
  en: {
    eyebrow: 'PORTFOLIO',
    title: 'Representative programs and model courses designed for business, education, and seasonal inbound travel across Japan.',
    intro: 'Each case combines travel objectives, operating conditions, and on-the-ground execution so clients can see how JBC TOURS structures tailored inbound programs at different scales.',
    itinerariesEyebrow: 'ITINERARIES',
    itinerariesTitle: '',
    itineraries: supplementaryItineraries,
    items: [
      {
        category: 'MICE',
        title: 'Corporate Incentive Travel Program',
        images: portfolioImages.mice,
        meta: ['Area: Nagoya', 'Participants: 300 pax', 'Duration: 5 days'],
        sections: [
          {
            label: 'Background',
            body: [
              'As part of a Japan market exploration initiative, we were requested to design a corporate incentive program incorporating immersive Japanese cultural experiences.'
            ]
          },
          {
            label: 'Objective',
            body: [
              'To enhance employee engagement and team cohesion, while ensuring seamless operations and delivering a comfortable, high-quality travel experience.'
            ]
          },
          {
            label: 'Solution',
            body: [
              'We designed a premium program aligned with the cherry blossom season, including a fully equipped venue setup and curated cultural experiences.',
              'The itinerary featured Japanese cultural performances such as traditional dance shows, tuna cutting demonstrations, and hands-on sushi-making experiences, as well as interactive wellness product experiences.'
            ]
          },
          {
            label: 'Execution',
            body: [
              'Our dedicated on-site operations team managed end-to-end coordination, including venue setup, logistics, and guest support.',
              'Despite the large scale of the group, we ensured smooth operations and a highly satisfactory experience for all participants.'
            ]
          }
        ]
      },
      {
        category: 'Educational Program',
        title: 'Youth Study & Cultural Exchange Program in Japan',
        images: portfolioImages.education,
        meta: ['Area: Tokyo / Osaka', 'Participants: 40–60 pax', 'Duration: 7 days'],
        sections: [
          {
            label: 'Background',
            body: [
              'We operate inbound educational programs for international youth, including summer and winter camps featuring cultural exchange activities with Japanese students.'
            ]
          },
          {
            label: 'Objective',
            body: [
              'To enhance cross-cultural communication skills through exposure to Japanese traditional culture and contemporary pop culture.'
            ]
          },
          {
            label: 'Solution',
            body: [
              'We designed a balanced itinerary combining academic and cultural experiences, including visits to leading universities, as well as cultural exploration in areas such as Akihabara anime district and other modern cultural hubs.'
            ]
          },
          {
            label: 'Execution',
            body: [
              'We coordinated closely with schools and youth accommodation facilities such as educational lodgings and training centers.',
              'A strong focus was placed on safety management and structured operational support throughout the program.'
            ]
          }
        ]
      },
      {
        category: 'Series Tours',
        title: 'Seasonal Themed Tours (Cherry Blossom & Autumn Leaves Programs)',
        images: portfolioImages.seasonal,
        meta: ['Area: Osaka / Nara / Kyoto / Mt. Fuji–Hakone / Tokyo', 'Participants: 40–90 pax', 'Duration: 7–10 days'],
        sections: [
          {
            label: 'Background',
            body: [
              'We operate recurring seasonal group tours during Japan’s cherry blossom and autumn foliage periods, welcoming international tour groups annually.'
            ]
          },
          {
            label: 'Objective',
            body: [
              'To provide a well-balanced travel experience across Japan’s key destinations during peak seasonal viewing periods.'
            ]
          },
          {
            label: 'Solution',
            body: [
              'We designed multi-regional itineraries covering major sightseeing destinations across Japan, ensuring smooth travel flow and balanced program composition.'
            ]
          },
          {
            label: 'Execution',
            body: [
              'We arranged experienced multilingual guides for each region and selected restaurants capable of accommodating dietary requirements.',
              'We ensured consistent service quality and high participant satisfaction across all tour segments.'
            ]
          }
        ]
      }
    ]
  },
  ja: {
    eyebrow: '実績案件',
    title: 'MICE、教育旅行、季節テーマツアーまで、目的に応じて設計した訪日プログラムの実績をご紹介します。',
    intro: '参加人数、実施背景、提案内容、運営体制までを含めて整理し、JBC TOURSがどのように目的起点で旅を構築しているかをご覧いただけます。',
    itinerariesEyebrow: '参考行程',
    itinerariesTitle: '',
    itineraries: supplementaryItineraries,
    items: [
      {
        category: 'MICE',
        title: '【アジアの大手保険会社 社員旅行】',
        images: [
          {
            src: portfolioImages.mice[0].src,
            alt: 'アジア大手保険会社向けの社員旅行イベント'
          },
          {
            src: portfolioImages.mice[1].src,
            alt: '大規模な社員旅行プログラム'
          },
          {
            src: portfolioImages.mice[2].src,
            alt: '日本文化体験を含む企業インセンティブ旅行'
          },
          {
            src: portfolioImages.mice[3].src,
            alt: '桜シーズンの会場演出と運営体制'
          },
          {
            src: portfolioImages.mice[4].src,
            alt: '健康商品体験と余興を組み合わせたプログラム'
          }
        ],
        meta: ['エリア：名古屋', '参加人数：300名', '期間：5日間'],
        sections: [
          {
            label: '背景',
            body: [
              '海外企業による日本市場視察の一環として、日本文化を通じた非日常体験を組み込んだ旅行企画のご依頼をいただきました。'
            ]
          },
          {
            label: '目的',
            body: [
              '単なる日本の商品・文化体験にとどまらず、社員同士の結束力を高めること、また、スムーズな運営により快適なひとときを実現させること。'
            ]
          },
          {
            label: '提案内容',
            body: [
              '桜シーズンと掛け合わせた豪華絢爛な会場を手配し、健康商品の体験や相談、余興として日本舞踊のパフォーマンスショーやマグロ解体ショー、寿司製作体験を提案。'
            ]
          },
          {
            label: '実施内容',
            body: [
              '弊社特別手配の専門チームが会場設営、運営、サポートまで一貫して担当し、大規模ながらもスムーズでご満足いただけるツアーを実現させました。'
            ]
          }
        ]
      },
      {
        category: '教育団体',
        title: '【青少年日本留学体験ツアー】',
        images: [
          {
            src: portfolioImages.education[0].src,
            alt: '青少年向け日本留学体験ツアー'
          },
          {
            src: portfolioImages.education[1].src,
            alt: '文化交流を含む教育旅行プログラム'
          },
          {
            src: portfolioImages.education[2].src,
            alt: '大学訪問を含む学術体験'
          },
          {
            src: portfolioImages.education[3].src,
            alt: '安全管理を重視した宿泊研修運営'
          },
          {
            src: portfolioImages.education[4].src,
            alt: '秋葉原など現代文化を学ぶ行程'
          }
        ],
        meta: ['エリア：東京・大阪', '参加人数：40~60名', '期間：7日間'],
        sections: [
          {
            label: '背景',
            body: [
              '日本の小中学生との交流や文化体験を含むスタディツアーとして、サマー/ウインターキャンプを受け入れております。'
            ]
          },
          {
            label: '目的',
            body: [
              '日本の伝統文化・ポップカルチャーを通して異文化コミュニケーション能力を向上させること。'
            ]
          },
          {
            label: '提案内容',
            body: [
              '名門大学の訪問や秋葉原のアニメ街散策など、学術分野から現代のエンタメまで広く体験できる行程を提案。'
            ]
          },
          {
            label: '実施内容',
            body: [
              '小中学校や青少年の家等の宿泊施設との綿密なやり取りを重ね、安全を第一としたサポート体制を整えた運営を実現させました。'
            ]
          }
        ]
      },
      {
        category: 'シリーズツアー',
        title: '【桜・紅葉シーズンのテーマ別ツアー】',
        images: [
          {
            src: portfolioImages.seasonal[0].src,
            alt: '桜と紅葉シーズンのテーマ別ツアー'
          },
          {
            src: portfolioImages.seasonal[1].src,
            alt: '日本各地を巡る季節観光ルート'
          },
          {
            src: portfolioImages.seasonal[2].src,
            alt: '地域ごとのガイド付き観光体験'
          },
          {
            src: portfolioImages.seasonal[3].src,
            alt: 'ピークシーズンの団体移動と行程設計'
          },
          {
            src: portfolioImages.seasonal[4].src,
            alt: '食事対応も含めた満足度の高い運営'
          }
        ],
        meta: ['エリア：大阪・奈良・京都・富士箱根・東京', '参加人数：40~90名', '期間：7~10日間'],
        sections: [
          {
            label: '背景',
            body: [
              '毎年桜と紅葉の時期に、観光ツアーとして定期募集ツアーの団体様を受け入れております。'
            ]
          },
          {
            label: '提案内容',
            body: [
              'エリアを横断しての観光に伴い、バランスの取れた観光地・行程を提案。'
            ]
          },
          {
            label: '実施内容',
            body: [
              '各エリアに精通したガイド、食事制限等にも対応したレストランを手配し、参加者一人ひとりの満足度向上に努めました。'
            ]
          }
        ]
      }
    ]
  }
};

export default {
  name: 'Cases',
  props: {
    language: {
      type: String,
      default: 'en'
    }
  },
  computed: {
    content: function () {
      return portfolioContent[this.language] || portfolioContent.en;
    }
  }
};
</script>

<style scoped>
.portfolio-hero {
  padding-bottom: 24px;
}

.portfolio-hero__summary-bar {
  display: grid;
  gap: 8px 18px;
  grid-template-columns: auto minmax(0, 1.2fr) minmax(280px, 0.9fr);
  align-items: center;
  max-width: 1180px;
  padding: 18px 24px;
  border-radius: 18px;
  border: 1px solid rgba(15, 76, 129, 0.08);
  background: linear-gradient(90deg, rgba(15, 76, 129, 0.05), rgba(255, 255, 255, 0.92));
}

.portfolio-hero__summary-bar .page-copy {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.7;
}

.portfolio-hero__note {
  margin: 0;
  color: var(--color-muted);
  line-height: 1.7;
}

.portfolio-cases-section {
  padding-top: 0;
}

.portfolio-cases__viewport {
  width: min(calc(100% - 32px), 1480px);
  margin: 0 auto;
}

.portfolio-cases {
  display: grid;
  gap: 28px;
}

.portfolio-case {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  gap: 28px;
  padding: 28px;
  align-items: start;
}

.portfolio-case--reverse {
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
}

.portfolio-case--reverse .portfolio-case__gallery {
  order: 2;
}

.portfolio-case__gallery {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-rows: 180px;
  gap: 12px;
}

.portfolio-case__image-tile {
  margin: 0;
  overflow: hidden;
  border-radius: 18px;
}

.portfolio-case__image-tile--hero {
  grid-column: span 2;
  grid-row: span 2;
}

.portfolio-case__gallery img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.portfolio-case__body {
  display: grid;
  gap: 18px;
}

.portfolio-case__body h2 {
  margin: 0;
  font-size: clamp(28px, 3vw, 38px);
  line-height: 1.35;
}

.portfolio-case__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.portfolio-case__meta span {
  display: inline-flex;
  padding: 7px 14px;
  border-radius: 999px;
  background: rgba(15, 76, 129, 0.08);
  color: var(--color-accent-deep);
  font-size: 12px;
  letter-spacing: 0.06em;
}

.portfolio-case__sections {
  display: grid;
  gap: 18px;
}

.portfolio-case__sections section {
  display: grid;
  gap: 8px;
}

.portfolio-case__sections h3 {
  margin: 0;
  font-size: 18px;
}

.portfolio-case__sections p {
  margin: 0;
  color: var(--color-muted);
  line-height: 1.8;
}

@media (max-width: 1023px) {
  .portfolio-hero__summary-bar {
    grid-template-columns: 1fr;
    align-items: start;
  }

  .portfolio-cases__viewport {
    width: min(calc(100% - 32px), 100%);
  }

  .portfolio-case,
  .portfolio-case--reverse {
    grid-template-columns: 1fr;
  }

  .portfolio-case--reverse .portfolio-case__gallery {
    order: 0;
  }
}

.portfolio-itineraries__intro,
.portfolio-itinerary {
  padding: 32px;
}

.portfolio-itineraries__intro {
  margin-bottom: 20px;
}

.portfolio-itineraries__list {
  display: grid;
  gap: 24px;
}

.portfolio-itinerary__header h3 {
  margin: 0 0 18px;
  font-size: 28px;
  line-height: 1.4;
}

.portfolio-itinerary__table-wrap {
  overflow-x: auto;
}

.portfolio-itinerary__table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
}

.portfolio-itinerary__table th,
.portfolio-itinerary__table td {
  padding: 16px 18px;
  border: 1px solid rgba(15, 76, 129, 0.08);
  text-align: left;
  vertical-align: top;
}

.portfolio-itinerary__table th {
  background: rgba(15, 76, 129, 0.06);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.portfolio-itinerary__table td {
  color: var(--color-muted);
  line-height: 1.8;
}

.portfolio-itinerary__table td:first-child {
  min-width: 88px;
  color: var(--color-text);
  font-weight: 600;
}

.portfolio-itinerary__table td:nth-child(2),
.portfolio-itinerary__table td:nth-child(3),
.portfolio-itinerary__table td:nth-child(5),
.portfolio-itinerary__table td:nth-child(6) {
  min-width: 140px;
}

.portfolio-itinerary__table td:nth-child(4) {
  min-width: 360px;
}

.portfolio-itinerary__table p {
  margin: 0 0 8px;
}

.portfolio-itinerary__table p:last-child {
  margin-bottom: 0;
}

@media (max-width: 767px) {
  .portfolio-itineraries__intro,
  .portfolio-itinerary {
    padding: 22px;
  }
}

@media (max-width: 767px) {
  .portfolio-hero__summary-bar,
  .portfolio-case {
    padding: 22px;
  }

  .portfolio-cases__viewport {
    width: min(calc(100% - 24px), 100%);
  }

  .portfolio-case__gallery {
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 130px;
  }

  .portfolio-case__body h2 {
    font-size: 24px;
  }
}
</style>
